import React from 'react';
import { Gift } from 'lucide-react';
export function Bonuses() {
  const bonuses = [{
    num: '01',
    title: '50 Actividades Acuícolas Listas para Usar',
    desc: 'Actividades de comprensión, cálculo técnico, prácticas de campo, dinámicas grupales y proyectos integradores. Organizadas por tomo y nivel de dificultad. Entrás al aula y ejecutás.',
    value: 'USD 47'
  }, {
    num: '02',
    title: 'Evaluaciones y Rúbricas Pro',
    desc: '6 exámenes teóricos completos — uno por tomo —, listas de cotejo para prácticas de laboratorio y campo, rúbricas analíticas para proyectos y un banco de 100 preguntas técnicas clasificadas por nivel de dificultad.',
    value: 'USD 37'
  }, {
    num: '03',
    title: 'Proyectos Prácticos Acuícolas',
    desc: '45 proyectos integradores con duración de 1 a 12 semanas. Producción acuícola, calidad del agua, sustentabilidad, alimentación, sistemas innovadores y emprendimiento. Con instrucciones, entregables y criterios de evaluación.',
    value: 'USD 47'
  }, {
    num: '04',
    title: 'Planificación Anual Editable',
    desc: '40 semanas de planificación completa: objetivos, contenidos, cronograma, actividades, evaluaciones y competencias. Lista para editar y usar en cualquier institución técnica. Incluye versión intensiva de 6 meses.',
    value: 'USD 37'
  }];
  return <section className="py-8 px-4 bg-brand-creamAlt border-y-2 border-brand-line" data-id="element-19">
      <div className="max-w-5xl mx-auto" data-id="element-20">
        <div className="text-center mb-6" data-id="element-21">
          <div className="inline-flex items-center bg-brand-red text-white font-display font-bold uppercase text-xs md:text-sm tracking-widest px-4 py-1.5 rounded-full mb-3" data-id="element-22">
            <Gift className="w-4 h-4 mr-1.5" data-id="element-23" /> 4 Bonos Estratégicos · GRATIS
          </div>
          <h2 className="text-3xl md:text-5xl font-display font-bold text-brand-navy uppercase leading-tight" data-id="element-24">
            Incluidos sin{' '}
            <span className="yellow-highlight" data-id="element-25">costo adicional</span>
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-5" data-id="element-26">
          {bonuses.map((b, i) => <div key={i} className="brunson-card rounded-lg p-4 md:p-5 relative" data-id="element-27">
              <div className="absolute -top-3 -left-3 bg-brand-yellowDark text-brand-navy font-display font-bold px-3 py-1 rounded-md border-2 border-brand-navy text-xs uppercase tracking-widest" data-id="element-28">
                Bono {b.num}
              </div>
              <h3 className="font-display font-bold text-brand-navy text-base md:text-lg uppercase leading-tight mt-2 mb-2" data-id="element-29">
                🎁 {b.title}
              </h3>
              <p className="text-xs md:text-sm text-brand-mute leading-snug font-medium mb-3" data-id="element-30">
                {b.desc}
              </p>
              <div className="flex items-center gap-2 pt-2 border-t border-brand-line" data-id="element-31">
                <span className="text-brand-mute line-through font-bold text-sm" data-id="element-32">
                  {b.value}
                </span>
                <span className="text-brand-cta font-display font-bold text-base" data-id="element-33">
                  → GRATIS
                </span>
              </div>
            </div>)}
        </div>

        <div className="bg-brand-navy text-white rounded-lg p-5 text-center max-w-2xl mx-auto border-b-4 border-brand-yellow" data-id="element-34">
          <p className="text-sm md:text-base font-bold uppercase tracking-wide mb-1" data-id="element-35">
            Valor total de los bonos
          </p>
          <p className="font-display text-3xl md:text-5xl font-bold text-brand-yellow" data-id="element-36">
            <span className="line-through opacity-70 text-2xl md:text-3xl mr-2" data-id="element-37">
              USD 168
            </span>{' '}
            GRATIS
          </p>
          <p className="text-xs md:text-sm text-white/80 mt-1 font-medium" data-id="element-38">
            Incluidos sin costo adicional
          </p>
        </div>
      </div>
    </section>;
}